<div
	(click)="openSpecialInstructionsDialog()"
	[ellipsis-content]="specialInstructions || '--'"
	ellipsis
	fxLayoutAlign="{{ layoutAlign }}"
	style="cursor: pointer; width: calc(100% - 1px); height: 21px"
></div>
